import PropTypes from 'prop-types';
import { Container, Col, Row } from 'react-bootstrap';
import Footer from '../../layouts/footer/footer';
import Header from "../../layouts/header";
import {useLocation} from 'react-router-dom';
import './errorPage.css'
import Labels from '../../components/translations/translation.json'

function ErrorPage(props) {

    const location = useLocation();
    const isPlannedMaintenance = props.isPlannedMaintenance;
    const statusCode = location.state?.statusCode;
    console.log("props of isPlannedMaintenance",isPlannedMaintenance);
    const errorTextEN = () => {
        if(isPlannedMaintenance){
            return Labels['EN'].PLANNED_MAINTENANCE_CODE_ERROR
        }else if(statusCode === 404){
            return Labels['EN'].INVALID_QR_CODE_ERROR
        }else{
            return Labels['EN'].UNPLANNED_MAINTENANCE_CODE_ERROR
        }
        
    } 
    const errorTextFR = () => {
        if(isPlannedMaintenance){
            return Labels['FR'].PLANNED_MAINTENANCE_CODE_ERROR
        }else if(statusCode === 404){
            return Labels['FR'].INVALID_QR_CODE_ERROR
        }else{
            return Labels['FR'].UNPLANNED_MAINTENANCE_CODE_ERROR
        }
    }
    const errorTextNL = () => {
        if(isPlannedMaintenance){
            return Labels['NL'].PLANNED_MAINTENANCE_CODE_ERROR
        }else if(statusCode === 404){
            return Labels['NL'].INVALID_QR_CODE_ERROR
        }else{
            return Labels['NL'].UNPLANNED_MAINTENANCE_CODE_ERROR
        }
    }
    const errorTextDE = () => {
        if(isPlannedMaintenance){
            return Labels['DE'].PLANNED_MAINTENANCE_CODE_ERROR
        }else if(statusCode === 404){
            return Labels['DE'].INVALID_QR_CODE_ERROR
        }else{
            return Labels['DE'].UNPLANNED_MAINTENANCE_CODE_ERROR
        }
    } 


    return(
        <>
        <Header disableDropDown={true}/> 
        <Container fluid style={{height : '100%'}} className='container-errorPage-main'>
        <Row>
        <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
            <div>
            </div>
        </Col>
        <Col xl={6} lg={6} md={8} sm={10} xs={12} xxs={12} className="subContainer-errorPage">
        <Container fluid className='container-paras'>
            <Row className="row">
                <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                    <div className="div-error-text">
                    <p className="errorPage-text">{errorTextNL()}</p>
                    <p className="errorPage-text">{errorTextFR()}</p>
                    <p className="errorPage-text">{errorTextDE()}</p>
                    <p className="errorPage-text">{errorTextEN()}</p>
                    </div>
                </Col>
            </Row>
            </Container>
            </Col>
            <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}>
                <div>
                </div>
            </Col>
            </Row>
            <Footer />
        </Container>
        </>
    );

}

ErrorPage.propTypes = {
    isPlannedMaintenance: PropTypes.bool
};

export default ErrorPage;